import React from 'react'

import { withRouter } from 'react-router-dom'

import { Button, Dimmer, Divider, Form, Header, Icon, Message, Modal } from 'semantic-ui-react';

import { FormWrapper, Input } from 'components';

import './style.css';

import { API } from 'services';

class UserActivationScene extends React.Component {

  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      default: true,
      success: false,
      actions: {
        submit: {
          name: "Enregistrer",
          callback: this.handleSubmit
        }
      }
    };
  }

  componentDidMount() {

    let params = new URLSearchParams(window.location.search);

    if(!params.has('token')) {
      this.props.history.push('/');
    }

    this.setState({
      token: params.get('token')
    });
  }

  handleClose() {
    this.props.history.push('/');
  }

  handleSubmit(data, onSucess, onError) {

    this.setState({
      default: false,
      failure: false
    }, () => {

      if(data.password !== data.confirm_password) {

        onError({
          password: [
            'Les mots de passes ne sont pas identiques'
          ],
          confirm_password: []
        });

        return
      }

      //Remove password confirmation check
      delete data.confirm_password;

      console.log(this.state);

      // Adding token to data to be sent
      data.token = this.state.token;

      API.post('/users/activate', data)
        .then(() => {

          this.setState({
            success: true
          });

        })
        .catch((error) => {
          onError(API.violations(error));

          if(error.response.status === 404) {

            this.setState({
              failure: true
            });
          }

        });
    })
  }

  render() {

    return (
      <Modal id="user-activation" open size='small' dimmer="blurring">
        <Header icon="user" content="Bienvenue sur EquiSym" />
        <Modal.Content>

          {/* <FormWrapper> */}
          <Dimmer.Dimmable blurring dimmed={this.state.success}>
            <Dimmer active={this.state.success} inverted />

            {this.state.default &&
              <Message info>
                <p>Avant de commencer à utiliser le système Equisym, veuillez compléter les informations de votre profil</p>
              </Message>
            }

            {this.state.failure &&
              <Message error>
                Une erreur est survenue lors du traitement de votre demande
              </Message>
            }

            <FormWrapper actions={this.state.actions}>

              <Divider horizontal>
                Identité
              </Divider>

              <Form.Group widths='equal'>

                {/* Lastname */}
                <Form.Field>
                  <label htmlFor="lastname" className="required">Nom</label>
                  <Input id="lastname" name="lastname" autoComplete="off"/>
                </Form.Field>

                {/* Firstname */}
                <Form.Field>
                  <label htmlFor="firstname" className="required">Prénom</label>
                  <Input id="firstname" name="firstname" autoComplete="off"/>
                </Form.Field>

              </Form.Group>


              {/* Phone */}
              <Form.Field>
                <label htmlFor="phone">Numéro de téléphone</label>
                <Input id="phone" name="phone" type="tel" autoComplete="off"/>
              </Form.Field>

              <Divider horizontal>
                Sécurité
              </Divider>

              {/* Password */}
              <Form.Field>
                <label htmlFor="phone" className="required">Mot de passe</label>
                <Input id="password" name="password" type="password" autoComplete="off"/>
              </Form.Field>

              {/* Confirm password */}
              <Form.Field>
                <label htmlFor="phone" className="required">Confirmation du mot de passe</label>
                <Input id="confirm_password" name="confirm_password" type="password" autoComplete="off"/>
              </Form.Field>

            </FormWrapper>

          </Dimmer.Dimmable>

          {/* Success */}
          {this.state.success &&
            <div className="overlay">
              <Icon name="checkmark" size="huge" color="green" />
              <span>Vous êtes prèt a utiliser le système EquiSym</span>
              <Button color="green" onClick={this.handleClose}>C'est parti !</Button>
            </div>
          }

        </Modal.Content>
      </Modal>
    );
  }
}

export default withRouter(UserActivationScene);
